import React, { useCallback, useEffect, useState } from "react";
import MobileDetect from "mobile-detect";

const APP_BREAKPOINT = 800;
const parseItem = (item) => {
  if (typeof item === "string") {
    return <img src={item} alt="" />;
  }
  if (typeof item === "function") {
    return item();
  }
  return item;
};

export const useBrowserLayout = ({
  designWidth = 1290,
  designHeight = 2796,
  designOffset = 300,
} = {}) => {
  const [isAppLayout, setIsAppLayout] = useState();
  const [isMobileLayout, setIsMobileLayout] = useState();
  const [isMobile, setIsMobile] = useState();
  const [isWXBrowser, setIsWXBrowser] = useState(false);
  const [md, setMd] = useState();
  const [isNative, setIsNative] = useState();

  // 检查浏览器信息
  useEffect(() => {
    setIsNative(!!window.ReactNativeWebView);
    if (window.ReactNativeWebView) {
      document.documentElement.classList.add("is_native");
    }
    const md = new MobileDetect(window.navigator.userAgent);
    const mobile = !!md.mobile();
    setMd(md);
    setIsWXBrowser(
      /micromessenger/.test(window.navigator.userAgent.toLowerCase())
    );
    setIsMobile(mobile);

    if (!mobile) {
      document.documentElement.classList.add("is_desktop");
    } else {
      document.documentElement.classList.add("is_mobile");
      // ios safari 的导航条会挡住底部
      setTimeout(() => {
        const viewH = window.innerHeight; // 浏览器的视窗高度
        const pageH = window.document.documentElement.offsetHeight; // 页面高度
        if (pageH > viewH) {
          // 以便 css 那边做缩放，将导航条的部分流出来
          document.documentElement.style.setProperty(
            "--scale-for-safari",
            viewH / pageH
          );
        }
      }, 300);
    }
  }, []);

  useEffect(() => {
    const resizeEvent = () => {
      const winWidth = window.document.documentElement.clientWidth;
      const isApp = winWidth < APP_BREAKPOINT;
      const htmlClassList = window.document.documentElement.classList;
      if (isApp) {
        htmlClassList.add("is_app");
      } else {
        htmlClassList.remove("is_app");
      }
      htmlClassList.add("theme-disabled");
      setIsAppLayout(isApp);
    };
    resizeEvent();
    window.addEventListener("resize", resizeEvent);

    return () => {
      window.removeEventListener("resize", resizeEvent);
    };
  }, []);

  // 检测网页是否近似手机比例
  useEffect(() => {
    const resize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      const matchRatio = w / h <= (designWidth + designOffset) / designHeight;
      setIsMobileLayout(matchRatio);
    };

    window.addEventListener("resize", resize);
    resize();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [designWidth, designHeight, designOffset]);

  // 为手机比例的网页添加 class
  useEffect(() => {
    const classList = document.documentElement.classList;
    if (isMobileLayout) {
      classList.add("is_matchRatio");
    } else {
      classList.add("is_notMatchRatio");
    }

    return () => {
      classList.remove("is_notMatchRatio");
      classList.remove("is_matchRatio");
    };
  }, [isMobileLayout]);

  const renderItem = useCallback(
    (forPc, forApp) => {
      if (isAppLayout === undefined) {
        return null;
      }

      if (isAppLayout) {
        return parseItem(forApp);
      }

      return parseItem(forPc);
    },
    [isAppLayout]
  );

  return {
    md,
    isMobile,
    isMobileLayout,
    isAppLayout,
    isWXBrowser,
    renderItem,
    isNative,
  };
};
